/**
 * @generated SignedSource<<1e52d25aad3192ce7ec99aeeeb731967>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OrderStatus = "abandoned" | "advance" | "canceled" | "draft" | "paid" | "pending" | "trash";
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainForm_order$data = {
  readonly adminComment: string | null;
  readonly id: string;
  readonly status: OrderStatus;
  readonly " $fragmentType": "OrderEditMainForm_order";
};
export type OrderEditMainForm_order$key = {
  readonly " $data"?: OrderEditMainForm_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainForm_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainForm_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "3832a6d6d3072bdf9933f8d1149f7506";

export default node;
